import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import styles from './LeadLog.module.css';
import Filter from "../../components/Filter/Filter";
import Sort from "../../components/Sort/Sort";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { CaseContext } from "../CaseContext";
import Pagination from "../../components/Pagination/Pagination";
import api from "../../api"; // adjust the path as needed
import { SideBar } from "../../components/Sidebar/Sidebar";

export const LeadLog = () => {
  const location = useLocation();
  const newLead = location.state?.newLead || null; // Retrieve new lead data passed from CreateLead
  const { updateLeadLogCount } = location.state || {}; // Callback function to update lead count in the sidebar
  const [leadLogData, setLeadLogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { caseDetails } = location.state || {};
    const { selectedCase, setSelectedLead } = useContext(CaseContext);

       const [showFilter, setShowFilter] = useState(false);
      const [showSort, setShowSort] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const totalPages = 10; // Change based on your data
    const totalEntries = 100;

  // Filter and Sort state
  const filterButtonRefs = useRef({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterConfig, setFilterConfig] = useState({
    leadNo: [],
    description: [],
    assignedDate: [],
    leadStatus: [],
    assignedTo: [],
    submittedDate: [],
    approvedDate: []
  });
  const [openFilter, setOpenFilter] = useState(null);
  const [filterSearch, setFilterSearch] = useState({});
  const [tempFilterSelections, setTempFilterSelections] = useState({});
  

  const navigate = useNavigate(); // Initialize the navigate function

  const loggedInOfficer = localStorage.getItem("loggedInUser");
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    api.get("/api/users/usernames")
      .then(({ data }) => setAllUsers(data.users || []))
      .catch(() => {});
  }, []);

  const displayUser = (uname) => {
    const u = allUsers.find((x) => x.username === uname);
    if (!u) return uname;
    const last  = (u.lastName  || "").trim();
    const first = (u.firstName || "").trim();
    const name  = last && first ? `${last}, ${first}` : last || first || "";
    return name ? `${name} (${u.username})` : u.username;
  };
  console.log(loggedInOfficer);
  const token = localStorage.getItem('token') || '';

  const getFormattedDate = () => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const year = today.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  const isInvestigator = selectedCase.role === 'Investigator';

  const generateIncidentNumber = () => {
    const numbers = leadEntries
      .map((entry) => Number(entry.leadNo))
      .filter((num) => !isNaN(num));
    const maxNumber = numbers.length ? Math.max(...numbers) : 0;
    return (maxNumber + 1).toString();
  };


  // useEffect(() => {
  //     if (caseDetails?.id && caseDetails?.title) {
  //       fetch(`http://localhost:5000/api/lead/case/${selectedCase.caseNo}/${selectedCase.caseName}`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         },
  //       })
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error(`HTTP error! status: ${response.status}`);
  //           }
  //           return response.json();
  //         })
  //         .then((data) => {
  //           console.log("✅ Fetched Leads Data:", data);
          
  //           const leadsArray = Array.isArray(data) ? data : [];
          
  //           const filteredLeads = leadsArray.filter((lead) => {
  //             if (
  //               lead.accessLevel === "Only Case Manager and Assignees" &&
  //               !lead.assignedTo?.includes(loggedInOfficer) &&
  //               lead.assignedBy !== loggedInOfficer
  //             ) {
  //               return false; // hide this lead
  //             }
  //             return true;
  //           });
          
  //           setLeadLogData(filteredLeads);
  //         })
          
  //         .catch((error) => {
  //           console.error("❌ Error fetching leads:", error.message);
  //         });
  //     }
  //   }, [selectedCase, token]);

  useEffect(() => {
    const fetchLeadLog = async () => {
      const caseId = selectedCase._id || selectedCase.id;
      if (caseId) {
        try {
          const token = localStorage.getItem("token");

          const response = await api.get(
            `/api/lead/case/${caseId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          const leadsArray = Array.isArray(response.data)
            ? response.data
            : [];
  
          const systemRole = localStorage.getItem("systemRole") || localStorage.getItem("role");
          const privileged = ["Admin", "Detective Supervisor"].includes(systemRole) ||
            ["Detective Supervisor", "Case Manager"].includes(selectedCase?.role);

          const filteredLeads = leadsArray.filter((lead) => {
            if (privileged) return true;
            return !(
              lead.accessLevel === "Only Case Manager and Assignees" &&
              !lead.assignedTo?.some(o => o.username === loggedInOfficer) &&
              lead.assignedBy !== loggedInOfficer
            );
          });
  
          setLeadLogData(filteredLeads);
          console.log("✅ Fetched Leads Data:", response.data);
        } catch (error) {
          console.error("❌ Error fetching leads:", error.message);
        }
      }
    };
  
    fetchLeadLog();
  }, [selectedCase, token, loggedInOfficer]);
  
    
  


  const handleBackClick = () => {
    navigate("/casepagemanager"); // Navigate to the Case Page Manager
  };


  const handleLeadClick = (lead) => {
    setSelectedLead({
      leadNo: lead.leadNo,
      leadName: lead.description,
    });
    navigate("/LeadReview", { state: { lead } }); // Navigate to lead details page with lead data
  };


  const defaultEntries = [
    {
      leadNumber: "7",
      leadSummary: "Investigate Mr.John",
      dateCreated: "12/15/24",
      status: "Created",
      assignedOfficer: [], // Assigned officers
      dateSubmitted: "",
      dateApproved: "",
    },
    {
      leadNumber: "1",
      leadSummary: "Investigate missing person case on 5th Avenue",
      dateCreated: "12/15/24",
      status: "Pending",
      assignedOfficer: ["Officer 1", "Officer 5"], // Assigned officers
      dateSubmitted: "",
      dateApproved: "",
    },
    {
      leadNumber: "3",
      leadSummary: "Interview witnesses for car accident on Main Street",
      dateCreated: "12/12/24",
      status: "Submitted",
      assignedOfficer: ["Officer 4", "Officer 8"], // Assigned officers
      dateSubmitted: "12/14/24",
      dateApproved: "",
    },
    {
      leadNumber: "9",
      leadSummary: "Interview witnesses for theft on Scubert Street",
      dateCreated: "12/12/24",
      status: "Returned",
      assignedOfficer: ["Officer 4", "Officer 8"], // Assigned officers
      dateSubmitted: "12/14/24",
      dateApproved: "",
    },
    {
      leadNumber: "2",
      leadSummary: "Check surveillance footage for recent robbery",
      dateCreated: "12/10/24",
      status: "Completed",
      assignedOfficer: ["Officer 2"], // Assigned officers
      dateSubmitted: "12/16/24",
      dateApproved: "12/18/24",
    },
  ];


  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [filterCategory, setFilterCategory] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filteredEntries, setFilteredEntries] = useState(defaultEntries);


  // useEffect(() => {
  //   if (newLead && newLead.leadNumber) {
  //     setLeadEntries((prevEntries) => [...prevEntries, newLead]);
  //   }
  // }, [newLead]);


  const handleApplyFilter = () => {
    let filtered = leadEntries;


    if (filterCategory === "status" && filterValue) {
      filtered = filtered.filter((entry) => entry.status === filterValue);
    } else if (filterCategory === "assignedOfficer" && filterValue) {
      filtered = filtered.filter((entry) => entry.assignedOfficer.includes(filterValue));
    } else if (filterCategory === "leadNumber" && filterValue) {
      filtered = filtered.filter((entry) => entry.leadNumber === filterValue);
    } else if (filterCategory === "dateCreated" && dateRange.startDate && dateRange.endDate) {
      filtered = filtered.filter(
        (entry) =>
          new Date(entry.dateCreated) >= new Date(dateRange.startDate) &&
          new Date(entry.dateCreated) <= new Date(dateRange.endDate)
      );
    }


    setFilteredEntries(filtered);
  };


  const resetFilters = () => {
    setFilteredEntries(leadEntries);
    setFilterCategory("");
    setFilterValue([]);
    setDateRange({ startDate: "", endDate: "" });
  };



  // State to maintain a list of lead entries
  const [leadEntries, setLeadEntries] = useState(() => {
    // Retrieve from local storage if available
    const savedEntries = localStorage.getItem('leadEntries');
    const parsedEntries = savedEntries ? JSON.parse(savedEntries) : [];
    // Combine default entries with saved entries, ensuring no duplicates
    const combinedEntries = [
      ...defaultEntries,
      ...parsedEntries.filter(
        (entry) =>
          !defaultEntries.some((defaultEntry) => defaultEntry.leadNumber === entry.leadNumber)
      ),
    ];
    return combinedEntries;
  });


  const [filterStatus, setFilterStatus] = useState("all"); // State for status filter
  const [sortOption, setSortOption] = useState(""); // State for sort option




  // Effect to handle new lead data
  useEffect(() => {
    if (newLead && newLead.leadNumber) {
      // Append the new lead to the existing entries if not already present
      setLeadEntries((prevEntries) => {
        const isDuplicate = prevEntries.some(
          (entry) => entry.leadNumber === newLead.leadNumber
        );


        if (!isDuplicate) {
          const updatedEntries = [...prevEntries, { ...newLead, status: 'Pending' }];
          localStorage.setItem('leadEntries', JSON.stringify(updatedEntries)); // Save to local storage
          return updatedEntries;
        }


        return prevEntries;
      });
    }
  }, [newLead]);


   // Effect to save entries to local storage whenever they change
   useEffect(() => {
    localStorage.setItem("leadEntries", JSON.stringify(leadEntries));
    if (updateLeadLogCount) {
      updateLeadLogCount(leadEntries.length); // Update the lead count in the sidebar
    }
  }, [leadEntries, updateLeadLogCount]);

  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending
  const [appliedSortOption, setAppliedSortOption] = useState(""); // Applied sort option
const [appliedSortOrder, setAppliedSortOrder] = useState("asc"); // Applied sort order


// Apply sort functionality
const handleApplySort = () => {
  setAppliedSortOption(sortOption);
  setAppliedSortOrder(sortOrder);
};


// Reset sort functionality
const handleResetSort = () => {
  setSortOption("");
  setSortOrder("asc");
  setAppliedSortOption("");
  setAppliedSortOrder("asc");
};


  // Sort entries based on selected option and order
  const sortedEntries = [...filteredEntries].sort((a, b) => {
    const compareValue = sortOrder === "asc" ? 1 : -1; // Determine sort direction
 
    if (sortOption === "date") {
      return (new Date(a.dateCreated) - new Date(b.dateCreated)) * compareValue;
    }
    if (sortOption === "status") {
      return a.status.localeCompare(b.status) * compareValue;
    }
    if (sortOption === "assigned to") {
      return (a.assignedTo || "").localeCompare(b.assignedTo || "") * compareValue;
    }
    if (sortOption === "lead number") {
      return (parseInt(a.leadNumber) - parseInt(b.leadNumber)) * compareValue;
    }
    return 0;
  });

  const filtersConfig = [
    {
      name: "leadNumber",
      label: "Lead Number",
      options: ["45", "23", "14"],
    },
    {
      name: "leadName",
      label: "Lead Name",
      options: [
        "Collect Audio from Dispatcher",
        "Interview Mr. John",
        "Collect evidence from 63 Mudray Street",
      ],
    },
    {
      name: "DateCreated",
      label: "Date Created",
      options: ["01/06/25", "08/20/25", "02/06/25"],
    },
    {
      name: "Status",
      label: "Status",
      options: ["Assigned", "Pending", "Submitted", "Rejected", "Completed"],
    },
    {
      name: "assignedOfficers",
      label: "Assigned Officers",
      options: ["Officer 1", "Officer 2", "Officer 3"],
    },
    {
      name: "DateSubmitted",
      label: "Date Submitted",
      options: ["01/06/25", "08/20/25", "02/06/25"],
    },
    {
      name: "DateApproved",
      label: "Date Approved",
      options: ["01/06/25", "08/20/25", "02/06/25"],
    },
  ];

  const handleFilterApply = (filters) => {
    console.log("Applied Filters:", filters);
    // Perform filtering logic here (e.g., API call, state update)
  };

    const [sortField, setSortField] = useState(""); // Sorting field
  

   // Sort leads
   const handleSort = (field, order) => {
   
  };

  // Function to format dates as MM/DD/YY
const formatDate = (dateString) => {
  if (!dateString) return ""; // Handle empty dates
  const date = new Date(dateString);
  if (isNaN(date)) return ""; // Handle invalid dates

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year

  return `${month}/${day}/${year}`;
};

  // Column mapping for filter/sort
  const colKey = {
    "Lead #": "leadNo",
    "Log Summary": "description",
    "Date Created": "assignedDate",
    "Status": "leadStatus",
    "Assigned To": "assignedTo",
    "Date Submitted": "submittedDate",
    "Date Approved": "approvedDate"
  };

  const columnWidths = {
    "Lead #": "7%",
    "Log Summary": "auto",
    "Date Created": "11%",
    "Status": "8%",
    "Assigned To": "11%",
    "Date Submitted": "13%",
    "Date Approved": "12%"
  };

  // Compute distinct values for filters
  const distinctValues = useMemo(() => {
    const map = {
      leadNo: new Set(),
      description: new Set(),
      assignedDate: new Set(),
      leadStatus: new Set(),
      assignedTo: new Set(),
      submittedDate: new Set(),
      approvedDate: new Set()
    };

    leadLogData.forEach(lead => {
      map.leadNo.add(String(lead.leadNo || ""));
      map.description.add(lead.description || "");
      map.assignedDate.add(formatDate(lead.assignedDate));
      map.leadStatus.add(lead.leadStatus || "");

      // Handle assignedTo array
      if (Array.isArray(lead.assignedTo)) {
        lead.assignedTo.forEach(officer => {
          const uname = officer.username || officer;
          if (uname) map.assignedTo.add(displayUser(uname));
        });
      }

      map.submittedDate.add(formatDate(lead.submittedDate));
      map.approvedDate.add(formatDate(lead.approvedDate));
    });

    return Object.fromEntries(
      Object.entries(map).map(([key, set]) => [key, [...set].filter(v => v !== "")])
    );
  }, [leadLogData, allUsers]);

  // Filter and sort handlers
  const sortColumn = (dataKey, direction) => {
    setSortConfig({ key: dataKey, direction });
  };

  const handleFilterSearch = (dataKey, txt) =>
    setFilterSearch(fs => ({ ...fs, [dataKey]: txt }));

  const toggleSelectAll = (dataKey) => {
    const all = distinctValues[dataKey] || [];
    setTempFilterSelections(ts => ({
      ...ts,
      [dataKey]: ts[dataKey]?.length === all.length ? [] : [...all]
    }));
  };

  const allChecked = (dataKey) => {
    const sel = tempFilterSelections[dataKey] || [];
    return sel.length === (distinctValues[dataKey] || []).length;
  };

  const handleCheckboxToggle = (dataKey, v) => {
    setTempFilterSelections(ts => {
      const sel = ts[dataKey] || [];
      return {
        ...ts,
        [dataKey]: sel.includes(v)
          ? sel.filter(x => x !== v)
          : [...sel, v]
      };
    });
  };

  const applyFilter = (dataKey) => {
    setFilterConfig(fc => ({
      ...fc,
      [dataKey]: tempFilterSelections[dataKey] || []
    }));
    setOpenFilter(null);
  };

  // Filtered and sorted data
  const sortedFilteredLeads = useMemo(() => {
    // 1) Filter
    const filtered = leadLogData.filter(lead => {
      return Object.entries(filterConfig).every(([field, selected]) => {
        if (!selected || selected.length === 0) return true;

        if (field === "assignedTo") {
          const officers = Array.isArray(lead.assignedTo)
            ? lead.assignedTo.map(o => displayUser(o.username || o))
            : [];
          return officers.some(o => selected.includes(o));
        } else if (field === "assignedDate" || field === "submittedDate" || field === "approvedDate") {
          const value = formatDate(lead[field]);
          return selected.includes(value);
        } else {
          const value = String(lead[field] ?? "");
          return selected.includes(value);
        }
      });
    });

    // 2) Sort
    if (!sortConfig.key) return filtered;

    const { key, direction } = sortConfig;
    return [...filtered].sort((a, b) => {
      let aVal, bVal;

      if (key === "assignedTo") {
        const aOfficers = Array.isArray(a.assignedTo) ? a.assignedTo.map(o => o.username || o).join(", ") : "";
        const bOfficers = Array.isArray(b.assignedTo) ? b.assignedTo.map(o => o.username || o).join(", ") : "";
        aVal = aOfficers;
        bVal = bOfficers;
      } else if (key === "assignedDate" || key === "submittedDate" || key === "approvedDate") {
        aVal = a[key] ? new Date(a[key]).getTime() : 0;
        bVal = b[key] ? new Date(b[key]).getTime() : 0;
      } else if (key === "leadNo") {
        aVal = Number(a[key] ?? 0);
        bVal = Number(b[key] ?? 0);
        return direction === "asc" ? aVal - bVal : bVal - aVal;
      } else {
        aVal = String(a[key] ?? "");
        bVal = String(b[key] ?? "");
      }

      if (aVal < bVal) return direction === "asc" ? -1 : 1;
      if (aVal > bVal) return direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [leadLogData, filterConfig, sortConfig]);

  // Paginated data
  const paginatedLeads = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    return sortedFilteredLeads.slice(start, end);
  }, [sortedFilteredLeads, currentPage, pageSize]);

  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [caseDropdownOpen, setCaseDropdownOpen] = useState(true);
  const [leadDropdownOpen, setLeadDropdownOpen] = useState(true);

  const onShowCaseSelector = (route) => {
    navigate(route, { state: { caseDetails } });
};
  


  return (
    <div className={styles['lead-log-page']}>
      <Navbar />


      <div className={styles['main-container']}>
            {/* Sidebar */}
            {/* <div className="sideitem">
                    <ul className="sidebar-list">
                  
                   <li className="sidebar-item" onClick={() => navigate("/HomePage", { state: { caseDetails } } )} >Go to Home Page</li>
                   <li className="sidebar-item active" onClick={() => setCaseDropdownOpen(!caseDropdownOpen)}>
          Case Related Tabs {caseDropdownOpen ?  "▲": "▼"}
        </li>
        {caseDropdownOpen && (
      <ul >
           
            <li className="sidebar-item" onClick={() => navigate('/caseInformation')}>Case Information</li>        
            <li className="sidebar-item" onClick={() => navigate('/CasePageManager')}>Case Page</li>            
            {selectedCase.role !== "Investigator" && (
<li className="sidebar-item " onClick={() => onShowCaseSelector("/CreateLead")}>New Lead </li>)}
           
            <li className="sidebar-item"onClick={() => navigate('/SearchLead')}>Search Lead</li>
            <li className="sidebar-item" onClick={() => navigate('/LRInstruction')}>View Lead Return</li>
            <li className="sidebar-item active" onClick={() => onShowCaseSelector("/LeadLog")}>View Lead Log</li>
        
              {selectedCase.role !== "Investigator" && (
            <li className="sidebar-item" onClick={() => navigate("/CaseScratchpad")}>
              Add/View Case Notes
            </li>)}
           
            <li className="sidebar-item" onClick={() => onShowCaseSelector("/FlaggedLead")}>View Flagged Leads</li>
            <li className="sidebar-item" onClick={() => onShowCaseSelector("/ViewTimeline")}>View Timeline Entries</li>
            <li className="sidebar-item" onClick={() => navigate("/LeadsDesk", { state: { caseDetails } } )} >View Leads Desk</li>
            {selectedCase.role !== "Investigator" && (
            <li className="sidebar-item" onClick={() => navigate("/LeadsDeskTestExecSummary", { state: { caseDetails } } )} >Generate Report</li>)}

            </ul>)}

            <li className="sidebar-item" style={{ fontWeight: 'bold' }} onClick={() => setLeadDropdownOpen(!leadDropdownOpen)}>
          Lead Related Tabs {leadDropdownOpen ?  "▲": "▼"}
</li>
        {leadDropdownOpen && (
          <ul>
             <li className="sidebar-item" onClick={() => navigate('/leadReview')}>Lead Information</li>
            {selectedCase.role !== "Investigator" && (
  <li className="sidebar-item" onClick={() => navigate("/ChainOfCustody", { state: { caseDetails } } )}>
    View Lead Chain of Custody

  </li>
)}
</ul>)}
                    </ul>
                </div> */}
                <SideBar activePage="LeadLog" />
     

        <div className={styles['left-content']}>


         <div className={styles['case-header']}>
            <div className={styles['cp-head']}>
          <h2>CASE LOG</h2>
        </div>
        </div>

      {/* <div className="filter-sort-icons">
                    <button onClick={() => setShowFilter(true)} className="icon-button">
                      <img 
                        src={`${process.env.PUBLIC_URL}/Materials/filter.png`}
                        alt="Filter Icon"
                        className="icon-image"
                      />
                    </button>
                    <button onClick={() => setShowSort(true)} className="icon-button">
                      <img 
                        src={`${process.env.PUBLIC_URL}/Materials/sort1.png`}
                        alt="Sort Icon"
                        className="icon-image"
                      />
                    </button>
                  </div> */}

      {showFilter && (
        <div className={styles['popup-overlay']}>
          <div className={styles['popup-content']}>
            <button className={styles['close-popup-btn']} onClick={() => setShowFilter(false)}>
              &times;
            </button>
            <Filter filtersConfig={filtersConfig} onApply={handleFilterApply} />
            </div>
        </div>
      )}

  
      {showSort && (
        <div className={styles['popup-overlay']}>
          <div className={styles['popup-content']}>
            <button className={styles['close-popup-btn']} onClick={() => setShowSort(false)}>
              &times;
            </button>
            <Sort columns={["Lead Number", "Lead Name", "Due Date", "Priority", "Flag", "Assigned Officers", "Days Left"]} onApplySort={handleSort} />
            </div>
          </div>
      )}


      <div className={styles['table-section1']}>
      <div className={styles['table-section']}>
      <div className={styles['table-scroll-container']}>
        <table className={styles['leads-table']}>
          <thead>
            <tr>
              {["Lead #", "Log Summary", "Date Created", "Status", "Assigned To", "Date Submitted", "Date Approved"].map(col => {
                const dataKey = colKey[col];
                return (
                  <th key={col} style={{ width: columnWidths[col] }} className={styles['column-header1']}>
                    <div className={styles['header-title']}>
                      {col}
                      <span>
                        <button
                          ref={el => (filterButtonRefs.current[dataKey] = el)}
                          onClick={() => setOpenFilter(prev => prev === dataKey ? null : dataKey)}
                        >
                          <img src={`${process.env.PUBLIC_URL}/Materials/fs.png`} className={styles['icon-image']} alt="filter" />
                        </button>
                        <Filter
                          dataKey={dataKey}
                          distinctValues={distinctValues}
                          open={openFilter === dataKey}
                          anchorRef={{ current: filterButtonRefs.current[dataKey] }}
                          searchValue={filterSearch[dataKey] || ''}
                          selections={tempFilterSelections[dataKey] || []}
                          onSort={sortColumn}
                          onSearch={handleFilterSearch}
                          allChecked={allChecked}
                          onToggleAll={toggleSelectAll}
                          onToggleOne={handleCheckboxToggle}
                          onApply={applyFilter}
                          onCancel={() => setOpenFilter(null)}
                          numeric={dataKey === "leadNo"}
                        />
                      </span>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
          {paginatedLeads.length > 0 ? (
              paginatedLeads.map((entry, index) => (
                <tr key={index} >
                  <td>{entry.leadNo}</td>
                  <td>
                {(() => {
                  const desc = entry.description || "";
                  const isTruncated = desc.length > 100;
                  const isExpanded = expandedDescriptions[entry.leadNo];
                  const displayText = isTruncated && !isExpanded
                    ? desc.slice(0, 100) + "..."
                    : desc;

                  return (
                    <>
                      {isInvestigator ? (
                        <span>{displayText}</span>
                      ) : (
                        <span
                          className={styles['clickable-description']}
                          onClick={() => handleLeadClick(entry)}
                        >
                          {displayText}
                        </span>
                      )}
                      {isTruncated && (
                        <span
                          className={styles['read-more']}
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedDescriptions(prev => ({
                              ...prev,
                              [entry.leadNo]: !prev[entry.leadNo]
                            }));
                          }}
                        >
                          {isExpanded ? "Show less" : "Read more"}
                        </span>
                      )}
                    </>
                  );
                })()}
              </td>
                  <td>{formatDate(entry.assignedDate)}</td>
                  <td>{entry.leadStatus}</td>
                  <td className={styles['assigned-to-cell']}>
                    {entry.assignedTo?.map(o => displayUser(o.username || o)).join(", ") || "None"}
                  </td>
                  <td>{formatDate(entry.submittedDate)}</td>
                  <td>{formatDate(entry.approvedDate)}</td> 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className={styles['empty-cell']}>
                  No Leads Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
  currentPage={currentPage}
  totalEntries={sortedFilteredLeads.length}
  onPageChange={setCurrentPage}
  pageSize={pageSize}
  onPageSizeChange={setPageSize}
/>

      </div>


      {/* <div className="report-section">
        <label>Select Report Type: </label>
        <select className="dropdown">
          <option value="summary">Summary</option>
          <option value="detailed">Detailed</option>
        </select>
      </div> */}

       {/* FootBar with navigation */}
       {/* <FootBar onPrevious={() => navigate(-1)} /> */}
      </div>
      </div>
      </div>
    </div>
  );
};



